import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { makeStyles } from '@mui/styles'
import LogoUpload from '@/modules/letter-paper-settings/logo-upload'

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingTop: 100,
  },
}))

const LogoData = forwardRef(({ onSubmitted, onValid }, ref) => {
  const classes = useStyles()
  const uploadRef = useRef()
  useImperativeHandle(ref, () => ({
    save: () => {
      if (uploadRef.current) {
        uploadRef.current.save().then(onSubmitted)
      } else {
        onSubmitted()
      }
    },
  }))

  useEffect(() => {
    onValid(true)
  }, [])

  return (
    <div className={classes.wrapper}>
      <LogoUpload isHeaderEdit showDescription={false} showSaveButton={false} ref={uploadRef} />
    </div>
  )
})

export default LogoData
